import { useQuery } from "@tanstack/react-query";
import { fetchCostGlobals, type CostGlobalsResponse } from "@/services/cost_api";

export const costGlobalsKeys = {
  one: (flavorId: string | null) => ["cost-globals", flavorId] as const,
};

/**
 * Median price-per-gram-USD across in-scope supplier offers. Used by the
 * CostTile's "Use global median for unpriced rows" toggle. Fetched once
 * per flavor; refreshed every 5 minutes.
 */
export function useCostGlobals(
  flavorId: string | null,
  enabled: boolean,
): { data: CostGlobalsResponse | undefined; isPending: boolean } {
  const q = useQuery({
    queryKey: costGlobalsKeys.one(flavorId),
    queryFn: ({ signal }) => fetchCostGlobals(flavorId as string, signal),
    enabled: enabled && flavorId !== null,
    staleTime: 5 * 60 * 1000,
  });
  return { data: q.data, isPending: q.isPending };
}
